import {HttpClient, HttpEventType, HttpRequest, HttpResponse} from "@angular/common/http";
import {Injectable} from "@angular/core";
import "rxjs/add/operator/map";
import 'rxjs/add/operator/filter';
import { SystemAttachment} from "./nbinput.entity";
import {Observable} from "rxjs/Observable";

@Injectable()
export class NbinputUploadService {
  public upload(item:File,url:string):Observable<any>{
    const formData = new FormData();
    formData.append('file', item);
    const req = new HttpRequest('POST', url, formData, {
      reportProgress: true,
    });
    return this.http.request(req).filter(e => e instanceof HttpResponse || e.type === HttpEventType.UploadProgress).map(e => {
      let a = new SystemAttachment();
      if (e.type === HttpEventType.UploadProgress) {
        a.completed = false;
        a.success = false;
        a.progress = Math.round(100 * e.loaded / e.total);
        a.url = '';
        a.name = '';
        a.size = 0;
        a.type = '';
        a.id = 0;
        a.status = '上传中... ...';
      } else if (e instanceof HttpResponse) {
        a.completed = true;
        a.success = true;
        a.progress = 100;
        a.url = e.body['data']['url'];
        a.type = e.body['data']['type'];
        a.name = e.body['data']['name'];
        a.size = e.body['data']['size'];
        a.id = e.body['data']['id'];
        a.status = '上传成功';
      }
      return a;
    });
  }

  blobToFile(theBlob: Blob, fileName:string): File{
    let b: any = theBlob;
    b.lastModifiedDate = new Date();
    b.name = fileName;
    return <File>b;
  }

  constructor(
    private http: HttpClient,
  ){}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/nbinput/nbinput-upload.ts